// Keep dialogue and cue timings together so radio clips can be replaced easily.
export const SIGNAL_STATIC_SOUND = '/sounds/glitch-sound.mp3';
export const SIGNAL_HEARTBEAT_SOUND = '/sounds/corebound-heartbeat.wav';

export const LAST_SIGNAL_STORIES = {
  opening: {
    duration: 24000,
    designation: 'SECTOR 01 / THE BREACH',
    title: 'The last signal',
    continueLabel: 'Enter the first portal',
    skipLabel: 'Skip intro',
    chapters: [
      {
        at: 0,
        label: 'THE PORTAL NETWORK / BEFORE THE SILENCE',
        title: 'A thousand worlds. A sky full of voices.',
        detail: 'Then the Glitch Core found a way in.',
      },
      {
        at: 3.6,
        label: 'SIGNAL INTEGRITY FALLING',
        title: 'One galaxy at a time, the stars go silent.',
        speaker: 'RIFT LOOM',
        line: 'The corruption is spreading through the portal network.',
      },
      {
        at: 7.4,
        label: 'ONE TRANSMISSION REMAINS',
        title: 'Somewhere in the dark…',
        speaker: 'UNKNOWN VOICE / DISTRESS FREQUENCY',
        line: 'If anyone can hear this…',
      },
      {
        at: 11.2,
        label: 'DISTRESS FREQUENCY / STILL TRANSMITTING',
        title: '…someone is waiting.',
        speaker: 'UNKNOWN VOICE / DISTRESS FREQUENCY',
        line: '…keep the way home open.',
      },
      {
        at: 15.4,
        label: 'THE RIFT LOOM / AWAKENING',
        title: 'The last light finds you.',
        speaker: 'RIFT LOOM',
        line: 'Distress signal acquired. Turning the Core’s signal into a weapon.',
      },
      {
        at: 19.6,
        label: 'TEN SECTORS / ONE WAY FORWARD',
        title: 'Carry it home.',
        speaker: 'RIFT LOOM',
        line: 'Cross ten sectors. Break the Warden. Silence the Core.',
      },
    ],
    sounds: [
      [0.1, '/sounds/space-synth.mp3'],
      [3.6, SIGNAL_HEARTBEAT_SOUND],
      [15.4, '/sounds/boss_approaching.mp3'],
    ],
  },
  arrival: {
    duration: 22000,
    designation: 'SECTOR 10 / ORIGIN SIGNAL',
    title: 'The Core arrival',
    continueLabel: 'Face the Core',
    skipLabel: 'Skip to battle',
    chapters: [
      {
        at: 0,
        label: 'FINAL PORTAL / THE OTHER SIDE',
        title: 'And then… nothing.',
        detail: 'The portal closes behind you. Even the static falls silent.',
      },
      {
        at: 2.8,
        label: 'FIRST PULSE / SOMETHING WITHIN',
        title: 'Something breaks the silence.',
        detail: 'A pulse moves through the dark. The shell keeps its secret.',
      },
      {
        at: 6,
        label: 'SECOND PULSE / CONTAINMENT RINGS',
        title: 'The network ends here.',
        detail: 'Darkened galaxies hang captive in the Core’s signal.',
      },
      {
        at: 9.2,
        label: 'THIRD PULSE / THE GLITCH CORE',
        title: 'You found it.',
        speaker: 'RIFT LOOM',
        line: 'Signal source located.',
      },
      {
        at: 12.4,
        label: 'DISTRESS FREQUENCY / SIGNAL REACQUIRED',
        title: 'The same voice. Still holding on.',
        speaker: 'UNKNOWN VOICE / DISTRESS FREQUENCY',
        line: 'If anyone can hear this… keep the way home open.',
      },
      {
        at: 17,
        label: 'RIFT LOOM ONLINE / CONNECTION ESTABLISHED',
        title: 'They’re still out there.',
        speaker: 'RIFT LOOM',
        line: 'The signal is alive. Bring them home.',
      },
    ],
    sounds: [
      [2.8, SIGNAL_HEARTBEAT_SOUND],
      [6, SIGNAL_HEARTBEAT_SOUND],
      [9.2, SIGNAL_HEARTBEAT_SOUND],
      [17, '/sounds/dice-increase-power.mp3'],
    ],
  },
};
